var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Bahamas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M42.716,17C39.875,9.412,32.579,4,24,4c-6.753,0-12.711,3.356-16.332,8.481L14.595,17H42.716z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M42.716,31h-28.11L7.67,35.522C11.291,40.645,17.249,44,24,44C32.579,44,39.875,38.588,42.716,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M25.333,24.005L14.605,31h28.11C43.532,28.818,44,26.467,44,24s-0.468-4.818-1.284-7H14.595 L25.333,24.005z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M25.333,24.005L14.595,17l-6.927-4.519C5.365,15.739,4,19.707,4,24c0,4.294,1.366,8.263,3.67,11.522 L14.605,31L25.333,24.005z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Bahamas);
export default __webpack_public_path__ + "static/media/icons8-bahamas.e6f104f4265b7d404009a790be283fd7.svg";
export { ForwardRef as ReactComponent };